// src/components/CarouselSection.js
import React from "react";
import { Carousel } from "react-bootstrap";

const CarouselSection = () => {
  return (
    <Carousel fade>
      <Carousel.Item>
        <img
          src="/assets/banho.jpg"
          className="d-block carousel-image"
          alt="Banho e Tosa"
        />
        <Carousel.Caption>
          <h3>Banho e Tosa com Cuidado Especial</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          src="/assets/2.jpeg"
          className="d-block carousel-image"
          alt="Rações de Qualidade"
        />
        <Carousel.Caption>
          <h3>Rações de Qualidade</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          src="/assets/4.png"
          className="d-block carousel-image"
          alt="Acessórios para Pets"
        />
        <Carousel.Caption>
          <h3>Acessórios para Todos os Pets</h3>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};

export default CarouselSection;
